import React from 'react';
import Header from '../Home/Header';
import Footer from '../Home/Footer';
import Aboutus from './Aboutus';
import Aboutus2 from './Aboutus2';
import OurSkills from './OurSkills';

const About = () => {
  return (
    <>
      <Header />
      <Aboutus />
      <Aboutus2/>
      <OurSkills/>
      <Footer />
    </>
  );
}

export default About;
